<script>
  import QuestionnaireQuestionMixin from '../mixins/QuestionnaireQuestionMixin.vue'

  export default {
    name: 'RbQuestionnaireQuestionText',
    mixins: [ QuestionnaireQuestionMixin ]
  }
</script>
